export default "__VITE_ASSET__Dt2YPjyy__"